import { useMutation } from '@tanstack/react-query'

import { transferServices } from '../transferServices'

export const useCheckExternalWalletAddress = () =>
  useMutation({
    mutationFn: transferServices.checkExternalWalletAddress,
  })
